import { useCallback, useEffect } from "react";
import { usePointerDown } from "./usePointerDown";
import { useVideoPlayerRefs } from "../contexts/VideoPlayerRefs";
import { useStep } from "./useStep";

export const usePeripheralEvents = (
  enableKeyboard: boolean,
  enablePointer: boolean
) => {
  const { video } = useVideoPlayerRefs();
  const { stepBackward, stepForward } = useStep();

  const toggle = useCallback(async () => {
    if (video.current?.paused) {
      await video.current?.play();
    } else {
      video.current?.pause();
    }
  }, [video]);

  useEffect(() => {
    if (enableKeyboard) {
      const handler = async (e: KeyboardEvent) => {
        switch (e.code) {
          case "Space":
            return await toggle();
          case "ArrowLeft":
            return stepBackward();
          case "ArrowRight":
            return stepForward();
        }
      };

      document.addEventListener("keydown", handler);

      return () => {
        document.removeEventListener("keydown", handler);
      };
    }
  }, [toggle, enableKeyboard, stepBackward, stepForward]);

  const callback = useCallback(
    async (e: PointerEvent) => {
      if (e.currentTarget === e.target) {
        await toggle();
      }
    },
    [toggle]
  );

  usePointerDown({ on: enablePointer, ref: video, callback });
};
